import { truncate as truncateInternal } from 'lodash-es'

export function truncate(str: string, limit: number) {
  return truncateInternal(str, { length: limit })
}

export function isValidEmail(str: string): boolean {
  const regEx =
    /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/
  return str.match(regEx) !== null
}
